import styled from "styled-components";
import { borderRadius, space, colors, FontSizes } from "shared/styles/constants";

export const StyledCopyClipboard = styled.div`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: ${space.xxs} ${space.xs};

  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: ${borderRadius.m};
`;

export const StyledCopyClipboardForm = styled.form`
  width: 100%;
`;

export const StyledCopyClipboardField = styled.input`
  width: 100%;

  margin-right: ${space.m};
  padding: ${space.xs};

  background-color: transparent;
  color: ${colors.white};
  outline: 0;

  font-size: ${FontSizes.m};
`;

export const StyledCopyClipboardButton = styled.div`
  flex-shrink: 0;
`;
